module.exports = __webpack_public_path__ + "img/10551385_L.4d316396.png";